import { queryOptions } from '@tanstack/react-query';

import { queries } from '@api';
import { retrieveFundFromOrigin } from '@api/funds/api.funds.requests';

export const retrieveFundFromOriginOptions = queryOptions({
  queryKey: queries.funds.fundFromOrigin.queryKey,
  queryFn: () => retrieveFundFromOrigin(),
});
